// extracted by mini-css-extract-plugin
export default {"root":"d3Hn3T","content":"sgRW_A","title":"S332dL","list":"iP9EMW","item":"WUPHRp","icon":"qeBljK","text":"Te3GQa","bold":"rnxysd","button":"LuGLz8"};